import { atom } from 'jotai';
import { atomWithStorage, atomWithReset } from 'jotai/utils';

import type { CompanySortOptions } from '@/api/v4/organization.api';
import type { IOption } from '@/types';
import type { ISort } from '@/ui/table/table.types';

import type { GenAiRequestHistoryResult } from '@/api/v4/genai-request-history.api';
import type { ExploreOrganizationSuggestionResult } from '@/api/v4/organization-suggestions.api';

export type ExploreResult =
  | ExploreOrganizationSuggestionResult
  | GenAiRequestHistoryResult;
import type {
  CreateOrganizationDescriptionPayload,
  CreateOrganizationSuggestionPayload,
} from '@/api/v4/organization-suggestions.api';

export interface ExampleCompany {
  id: string;
  name: string;
  website: string;
  logoUrl: string;
}

export const exploreFormDescriptionState = atomWithStorage<string>(
  'exploreFormDescriptionState',
  '',
);

export const exploreFormLocationsState = atomWithReset<IOption[]>([]);

export const exploreFormExampleCompaniesState = atomWithReset<ExampleCompany[]>(
  [],
);

export const exploreResultsSelectedCompaniesState = atom<ExploreResult[]>([]);

export const exploreResultsCreatingCompaniesState = atom<ExploreResult[]>([]);

export const exploreResultsCreatedCompaniesState = atom<ExploreResult[]>([]);

export const exploreResultsSortState = atom<ISort<CompanySortOptions | null>>({
  sort: null,
  direction: 'desc',
});

export const isExploreRequestHistoryPaneOpenState = atom<boolean>(false);

export type ExploreHistoryPaneMode = 'history' | 'rounds';

export const exploreHistoryPaneModeState =
  atom<ExploreHistoryPaneMode>('history');

export const exploreViewingRoundNumberState = atom<number | null>(null);

export const isExploreRoundCreatingState = atom<boolean>(false);

export const generatedShortDescriptionsState = atom<Record<string, string>>({});

export type AIModelType =
  | CreateOrganizationSuggestionPayload['model']
  | CreateOrganizationDescriptionPayload['model'];

export type ExploreFormState = {
  enabledExploreAccountData: CreateOrganizationSuggestionPayload['enableExploreAccountData'];
  model: AIModelType;
};

export const exploreFormState = atom<ExploreFormState>({
  model: 'openai',
  enabledExploreAccountData: false,
});
